import * as React from "react";
import Masonry from "react-masonry-css";
import { css } from "emotion";
import { mediaQueries } from "../../shared/config";

import "./styles.css";

class TwoColumn extends React.Component {
  render() {
    const { mobile, notMobile, tablet, notTablet, smol } = mediaQueries;

    return (
      <div
        className={css`
          width: 70%;
          ${smol} {
            width: 80%;
          }
          ${mobile} {
            width: 95%;
          }
          box-sizing: content-box;
          margin: 0 auto;
        `}
      >
        <div
          className={css`
            ${tablet} {
              display: none;
            }
          `}
        >
          {" "}
          <Masonry
            breakpointCols={2}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {this.props.children}
          </Masonry>
        </div>
        <div
          className={css`
            ${notTablet} {
              display: none;
            }
          `}
        >
          {" "}
          <Masonry
            breakpointCols={1}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {this.props.children}
          </Masonry>
        </div>
      </div>
    );
  }
}

export default TwoColumn;
